import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
import { WindowRef } from '../service/WindowRef.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
declare var $: any;

@Component({
    selector: 'app-razorpay',
    templateUrl: './razorpay.component.html',
    styleUrls: ['./razorpay.component.css']
})
export class RazorpayComponent implements OnInit {
    txnId: string;
    rzp1: any;
    loading: boolean = false;
    secureNowTxnRefNo: any;
    transactionId: any = '';
    private onDestroy$: Subject<void> = new Subject<void>();

    //options for RazorPay
    options = {
        key: environment.covidRazorpayKey,
        //amount: this.savedTotalPremium, //  = INR 1
        name: 'Secure now',
        description: 'Purchase description',
        image: "https://pamstaging2.securenow.in/static/images/securenow_logo.svg",
        order_id: this.transactionId,
        //  callback_url: 'https://www.google.com',
        handler: function (response) {
            this.transactionId = localStorage.getItem("txnId");
            this.secureNowTxnRefNo = localStorage.getItem("txnRefNo");
            this.transactionData = {
                "txnId": this.secureNowTxnRefNo,
                "razorpaySignature": response.razorpay_signature,
                "razorpayPaymentId": response.razorpay_payment_id
            }

            if (typeof response.razorpay_payment_id == 'undefined' || response.razorpay_payment_id < 1) {
                alert("error with payment Id " + response.razorpay_payment_id);
            } else {
                this.loading = true;
                console.log("loading -" + this.loading);
                $.ajax({
                    url: environment.platform + "/platform-sales/api/transaction/payment-acknowledge-razorpay?secureNowTxnRefId=" + this.secureNowTxnRefNo + "&razorpayOrderId=" + this.transactionId + "&razorpaySignature=" + response.razorpay_signature + "&razorpayPaymentId=" + response.razorpay_payment_id,
                    type: "POST",
                    data: '',
                    contentType: "application/json; charset=utf-8",
                    success: function (data) {
                        this.loading = true;
                        console.log(data.message, data.success);
                        var status = data.success;
                        location.href = '/senior-citizen-transaction/status/' + status;
                    },
                    error: function (data) {
                        this.loading = true;
                        var status = false;
                        location.href = '/senior-citizen-transaction/status/' + status;
                        // alert(data.message);
                        this.transactionFailureSection = true;
                        // location.href = '/';
                    }
                })
            }

        },
        prefill: {

        },
        notes: {

        },
        theme: {
            color: "#005BAA"
        },
    };

    constructor(private router: Router, private activeRoute : ActivatedRoute, private _location: Location, private winRef: WindowRef,) {
        this.activeRoute.queryParams.subscribe(params => {
            this.transactionId = params['txnId'];
            this.secureNowTxnRefNo = params['txnRefNo'];
            localStorage.setItem("txnId", params['txnId'])
            localStorage.setItem("txnRefNo",params['txnRefNo'])
        });
    }

    ngOnInit() {
        this.openRazorpay();
    }


    openRazorpay() {
        this.loading = true;
        this.options.order_id = this.transactionId;
        this.rzp1 = new this.winRef.nativeWindow.Razorpay(this.options);
        this.rzp1.open();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
      }


}